
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Stotra "Pranamya Shirasa Devam" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property:'og:description',
            content:'Explore the full lyrics of Stotra "Pranamya Shirasa Devam" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid:'twitter:description',
            property:'twitter:description',
            content:'Ganpati stotra, pranamya shirasa devam stotra, pranamyashirasa, ganesh stotra, Ganesha blessings, pranamyashirasadevam lyrics, pranamya shirasa devam lyrics, pradmay sirsa devam, pranamya, pranamya shirsa devam lyrics, om pranamya shirasa devam, pranamya shirsa'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'pranamya shirasa devam stotra, pranamya shirasa devam lyrics in english, pranamya shirasa devam lyrics in marathi, pranamya shirasa devam lyrics, ganesha stotram lyrics, ganesha stotram, प्रणम्य शिरसा देवं, Ganesha Stotra, Lord Ganesha mantra,  Ganesha prayer, Ganesha Stotra lyrics, Ganesha blessings, Pranamya Shirasa Ganesha stotra, pradmay sirsa devam, pranamya, pranamya shirsa devam lyrics, om pranamya shirasa devam, pranamya shirsa' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/stotra/pranamyashirsha.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/stotra/pranamyashirsha.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Pranamya Shirasa Devam | Ganesha Stotra - प्रणम्य शिरसा देवं(महागणपतिस्तोत्रं)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/stotra/pranamyashirsha"
        },
        "headline": "Pranamya Shirasa Devam - प्रणम्य शिरसा देवं(महागणपतिस्तोत्रं)",
        "name" : "Pranamya Shirasa Devam - Ganesha Stotra",
        "description": "Explore the full lyrics of stotra 'Pranamya Shirasa Devam' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/stotra/pranamyashirsha.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  